import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-landing-page',
  templateUrl: './registration-landing-page.component.html',
  styleUrls: ['./registration-landing-page.component.scss']
})
export class RegistrationLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
